import React, { useState, useEffect } from "react";
import Pagination from "../../../common/pagination";
import { Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import { paginate } from "../../../utils/paginate";
import Table from "./../../../common/table";
import getService from "../../../services/getService";
import NoImage from "../../../assets/images/NoImage.png";
import { CSVLink } from "react-csv";

const CMSTable = () => {
  const [cms, setCMS] = useState([]);

  const fetchCMS = async () => {
    const data = await getService.handleCMSList();
    console.log("data", data);
    setCMS(data);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getPagedData = () => {
    const item_cms = paginate(cms, currentPage, pageSize);
    return { totalCount: cms.length, data: item_cms };
  };

  const { length: count } = cms;

  const { totalCount, data: item_cms } = getPagedData();

  const columns = [
    {
      key: "",
      label: "S.No",
      content: (item_cms) => <p>{cms.indexOf(item_cms) + 1}</p>,
    },
    { path: "title", label: "Title" },
    {
      path: "logo",
      label: "Logo",
      content: (c) => (
        <>
          {c.img1 !== null ? (
            <img
              style={{ width: "100px", height: "100px" }}
              src={c.img1}
              alt="Onclq.com"
            />
          ) : (
            <img
              style={{ width: "100px", height: "100px" }}
              src={NoImage}
              alt="Onclq.com"
            />
          )}
        </>
      ),
    },
    {
      key: "Action",
      label: "Action",
      content: (item_cms) => (
        <>
          <button
            class="btn btn-info btn-xs m-b-5 custom_btn"
            onClick={() => {
              navigate(`/admin/cmsform/${item_cms.id}`);
            }}
          >
            <i class="pe-7s-note" aria-hidden="true"></i>
          </button>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchCMS();
  }, []);

  if (count === 0) return <p>There are no item in the database.</p>;

  return (
    <>
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-bd lobidrag">
            <div class="panel-heading">
              <div class="panel-title">
                <h4>CMS List </h4>
              </div>
              <CSVLink data={item_cms} className="btn btn-outline-success">
                Download Report
              </CSVLink>
            </div>
            <div class="panel-body">
              <Table columns={columns} data={item_cms} />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-5">
          {/* <div class="dataTables_info" id="supplierList_info" role="status" aria-live="polite">Showing {cms} entries in the Database</div> */}
        </div>
        <div class="col-sm-7">
          <Pagination
            itemsCount={totalCount}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default CMSTable;
